var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{ref:"ComponentGallery",attrs:{"id":"ComponentGallery"}},[_c('div',[_c('component-gallery-header'),_c('section',{ref:"Content",attrs:{"id":"component-gallery-content","role":"main"}},[_c('keep-alive',[_c('router-view')],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }